import { createMuiTheme } from 'material-ui/styles';
import breakpoints from './breakpoints';
import palette from './palette';
import customize from './overrides';

const typography = {
  fontFamily: 'Nunito, Arial, sans-serif, dinpro-regular',
  fontWeight: 400,
  button: {
    fontFamily: 'Nunito, Arial, sans-serif, dinpro-bold',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
    textTransform: 'unset',
  },
};
const theme = createMuiTheme({
  palette,
  typography,
  breakpoints,
  transition: value => `${value} 0.3s ease-in-out`,
});

export default customize(theme);
